<template>
<div class="content"></div>
</template>

<script>
import {getLiveRoomId} from "@/api/zhibo";

export default {
  name: "payComeBack",
  data(){
    return {

    }
  },
  created() {
    let orderNumber = this.$route.query.merOrderId
    const data= {
      payment_no:orderNumber
    }
    getLiveRoomId(data).then(res => {
      console.log(res)
      if(res.code == 200)
      {
        let id = res.data.live_room_id
        this.$router.push({path:'/zhiBoDes',query: {id:id}})
      } else {
        // this.$toast(res.message)
        this.$dialog.alert({
          title: '错误提示',
          message: res.message,
          confirmButtonText: '返回首页'
        }).then(() => {
          // on close
          this.$router.push('/');
        });

      }
    })
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
